// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1Vm8G","loaderOuter":"PageOverlayLoader_loaderOuter__2N3C8"};